// extracted by mini-css-extract-plugin
export var addButton = "_nz-0";
export var border = "_nz-8";
export var check = "_nz-h";
export var danger = "_nz-6";
export var dropdownContainer = "_nz-1";
export var editModalBody = "_nz-j";
export var footerContainer = "_nz-i";
export var fullWidth = "_nz-a";
export var hide = "_nz-9";
export var icon = "_nz-3";
export var input = "_nz-7";
export var inputFlex = "_nz-b";
export var inputWrapper = "_nz-c";
export var manualFocus = "_nz-5";
export var optionButton = "_nz-4";
export var pillWrapper = "_nz-e";
export var pointer = "_nz-2";
export var showOverflow = "_nz-f";
export var tagsFlex = "_nz-d";
export var xButton = "_nz-g";